export default __webpack_public_path__ + "static/media/8.a41301a5.jpg";